import React from 'react';
import ReactDOM from 'react-dom';
import './../../scss/login-page.scss';
import App from './App';
import 'babel-polyfill';
import 'whatwg-fetch';
global._babelPolyfill = false;
ReactDOM.render(
  <App/>
  , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/scenes/admin-login/index.js